module.exports = __webpack_public_path__ + "img/11.2c331e49.jpg";